import { render } from "./HeaderContainer.vue?vue&type=template&id=3375f3f1&scoped=true&ts=true"
import script from "./HeaderContainer.vue?vue&type=script&lang=ts"
export * from "./HeaderContainer.vue?vue&type=script&lang=ts"

import "./HeaderContainer.vue?vue&type=style&index=0&id=3375f3f1&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3375f3f1"]])

export default __exports__